module.exports = __webpack_public_path__ + "media/Video 13b.c0daa1a0.mp4";